import { render, staticRenderFns } from "./ProofDetails.vue?vue&type=template&id=0e195f4a&scoped=true&lang=pug"
import script from "./ProofDetails.vue?vue&type=script&lang=js"
export * from "./ProofDetails.vue?vue&type=script&lang=js"
import style0 from "./ProofDetails.vue?vue&type=style&index=0&id=0e195f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e195f4a",
  null
  
)

export default component.exports